<template>
	<div class="form-content-composer-options-collapse">
    <form-input
        :label="$t('form_content_composer.options_input.label.label')"
        :value="value.label"
        :required="!['file'].find(type => type === value.type)"
        @input="onInput('label', $event)"
    />
	</div>
</template>

<script>
import _set from 'lodash/set'
import _cloneDeep from 'lodash/cloneDeep'

import FormInput from '@pixelstein/ps-form/components/PsFormInput'

export default {
  name: 'FormContentComposerOptionsCollapse',
  components: { FormInput },
  props: {
    value: { type: Object, default: () => ({ values: [] }) }
  },
  methods: {
    onInput (path, value) {
      console.log('onInput', path, value)
      const valueClone = _cloneDeep(this.value)
      _set(valueClone, path, value)

      this.$emit('input', valueClone)
    },
  },
}
</script>
